import { useState, useEffect, useCallback } from 'react';
import LoadingScreen from './components/LoadingScreen';
import Particles from './components/Particles';
import CursorGlow from './components/CursorGlow';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Barbers from './components/Barbers';
import Services from './components/Services';
import Marquee from './components/Marquee';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BookingModal from './components/BookingModal';
import { ParallaxDivider } from './components/Parallax';

import ScrollProgress from './components/ScrollProgress';
import BackToTop from './components/BackToTop';
import { WhatsAppButton } from './components/SocialSidebar';
import { fetchBarbers, fetchServices, fetchSalonInfo } from './data/api';
import './index.css';

export default function App() {
  const [loading, setLoading] = useState(true);
  const [bookingBarber, setBookingBarber] = useState(null);
  const [barbers, setBarbers] = useState([]);
  const [services, setServices] = useState([]);
  const [salonInfo, setSalonInfo] = useState(null);

  useEffect(() => {
    fetchBarbers().then(setBarbers).catch(() => {});
    fetchServices().then(setServices).catch(() => {});
    fetchSalonInfo().then(setSalonInfo).catch(() => {});
  }, []);

  const handleLoadingComplete = useCallback(() => {
    setLoading(false);
  }, []);

  if (loading) {
    return <LoadingScreen onComplete={handleLoadingComplete} />;
  }

  return (
    <>
      <div className="ambient-glow glow-1" />
      <div className="ambient-glow glow-2" />
      <div className="ambient-glow glow-3" />

      {/* Side Ornaments */}
      <div className="side-ornament left">
        <div className="side-line" />
        <div className="side-diamond" />
        <div className="side-dot" />
        <div className="side-line short" />
        <div className="side-diamond sm" />
        <div className="side-line" />
      </div>
      <div className="side-ornament right">
        <div className="side-line" />
        <div className="side-diamond" />
        <div className="side-dot" />
        <div className="side-line short" />
        <div className="side-diamond sm" />
        <div className="side-line" />
      </div>

      <ScrollProgress />
      <CursorGlow />
      <Particles />
      <Navbar />
      <WhatsAppButton />
      <BackToTop />

      <Hero />
      <Marquee />
      <Barbers barbers={barbers} onBooking={setBookingBarber} />
      <ParallaxDivider variant={1} />
      <Services services={services} />
      <ParallaxDivider variant={2} />
      <Contact info={salonInfo} />
      <Footer info={salonInfo} />

      {bookingBarber && (
        <BookingModal
          barberId={bookingBarber}
          services={services}
          onClose={() => setBookingBarber(null)}
        />
      )}
    </>
  );
}
